import {
    useMemo,
} from 'react'

import {
    ActionComponentsKey, ActionComponentsType,
} from 'app/PoC/DataGridDemoPages/SkyNetObjectRoutes/SkyNetObjectRoutes.types'
import hasPermission from 'app/utils/hasPermission'
import {
    useUserRoles,
} from 'app/Auth'

type Props = {
    actionComponents: ActionComponentsType | undefined
}

const useAllowedActionKeys = ({
    actionComponents,
}: Readonly<Props>) => {
    const roles = useUserRoles()

    return useMemo(() => {
        const actions = Object.entries(actionComponents || {})
        const allowedActions: ActionComponentsKey[] = []

        actions.forEach(([
            key,
            {
                accessOnly,
            },
        ]) => {
            if (!accessOnly?.length || hasPermission(accessOnly, roles)) {
                allowedActions.push(key as ActionComponentsKey)
            }
        })
        return allowedActions
    }, [
        actionComponents,
        roles,
    ])
}

export default useAllowedActionKeys
